import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../../translations';

const QUESTION_CONTENT_MAX_LENGTH = 280;

type QuestionContentCellProps = InteractiveTableCellProps<string>;

export const QuestionContentCell = (props: QuestionContentCellProps): JSX.Element => {
   return (
      <InteractiveTable.TextCell
         defaultValue={props.defaultValue}
         validationRules={{ maxLength: QUESTION_CONTENT_MAX_LENGTH, required: true }}
         index={props.index}
         name={props.name}
         testId={props.testId}
         placeholder={generalSettingsTranslationKeys.survey.preInterview.form.fields.content.placeholder}
      />
   );
};
